import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ServiceprovidertypesService } from '../../../_services/serviceprovidertypes/serviceprovidertypes.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-serviceprovidertype',
  templateUrl: './add-serviceprovidertype.component.html',
  styleUrls: ['./add-serviceprovidertype.component.css'],
  providers: [ServiceprovidertypesService]
})

//export class EditserviceprovidertypeComponent implements OnInit {
export class AddServiceprovidertypeComponent implements OnInit {

  serviceprovidertype: any = {};
  serviceid: number;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ServiceprovidertypesService: ServiceprovidertypesService
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.serviceid = params['id'];
    });

    this.ServiceprovidertypesService.getservice(this.serviceid).subscribe(
      res => {
        this.serviceprovidertype = res;
      }
    );

  }

  ngOnInit() {
  }
  img:any = '';
  @ViewChild("fileInput") fileInput;
  @ViewChild('update_locations') update_locations:ElementRef;
  updateServiceprovidertype() {
    this.update_locations.nativeElement.disabled = true;
    let fi = this.fileInput.nativeElement;
    if (fi.files && fi.files[0] && (fi.files[0].type == 'image/png' || fi.files[0].type == 'image/jpg' || fi.files[0].type == 'image/x-icon' || fi.files[0].type == 'image/gif' || fi.files[0].type == 'image/jpeg')) {
      let fileToUpload = fi.files[0];
      let image_type = fi.files[0].type.split('/');
      let time_name = Date.now();
      this.img = 'engines'+time_name + '.' + image_type[1];
      this.ServiceprovidertypesService.upload(fileToUpload,this.img).subscribe(
        res => {
       console.log(res);
        }
      );
    }
   this.ServiceprovidertypesService.addservice(this.serviceprovidertype,this.img).subscribe(
      res => {
        //this.router.navigate(['serviceprovidertypes']);
        window.location.reload();
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/serviceprovidertypes/add-serviceprovidertype/add-serviceprovidertype.component.ts